import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Filtro from 'containers/Relatorios/filtro';
import TitlePage from 'components/TituloPage';
import RelatorioStatusResumida from 'containers/Relatorios/relatorioResumido/statusResumido';
import { privateRoot } from 'routes/paths';
import { fetchGetRelatorioGrafico } from 'store/fetchActions/fetchRelatorios';
import { fetchGetTodosStatus } from 'store/fetchActions/fetchInputForm';
import { fetchBuscarSetores } from 'store/fetchActions/fetchSetores';
import { ENUM_TIPO_RELATORIO } from 'utils/consts';
import * as S from './styles';
import * as Style from 'components/Style';
import { montarDadosInputSelect } from 'utils/funcaoPadrao';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';

export default function PageRelatorioStatus() {
  const dispatch = useDispatch();
  const tipoRelatorio = ENUM_TIPO_RELATORIO.STATUS;

  const user = useSelector(state => state.sefaz.userProfile);
  const listaStatus = useSelector(state => state.status.todosStatus);

  const [filtroSelecionado, setFiltroSelecionado] = useState({});
  const [dadosGrafico, setDadosGrafico] = useState([]);
  const [todosSetores, setSetores] = useState([]);

  React.useEffect(() => {
    dispatch(fetchGetTodosStatus(listaStatus));
    dispatch(fetchBuscarSetores(false)).then(res => setSetores(res));
  }, [dispatch, listaStatus]);

  const pesquisarDados = filtro => {
    dispatch(fetchGetRelatorioGrafico(filtro))
      .then(res => setDadosGrafico(res?.periodo))
      .catch(() => setDadosGrafico([]));
  };

  const clearDados = () => {
    setDadosGrafico([]);
  };

  return (
    <S.Page>
      <TitlePage textTitle={'Relatório por Status'} backPage={privateRoot} />
      <Filtro
        salvarFiltro={filtro => setFiltroSelecionado(filtro)}
        funcPesquisar={filtro => pesquisarDados(filtro)}
        tipoRelatorio={tipoRelatorio}
        cleanDadosGrafico={clearDados}
        dadosGrafico={dadosGrafico}
        filtro={filtroSelecionado}
        relatorioNome={'Relatorio_Status'}
        todosSetores={montarDadosInputSelect(todosSetores, 'id', 'nome')}
        showInputSetor={user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL}
      />

      <Style.GlobalCard>
        <S.Descricao>
          <h2>Relatório dos Requerimentos por Status</h2>
          Cada requerimento pode ter um status por vez, esse status mostra em qual processo o requerimento está no
          momento. Os status são:&nbsp;
          {listaStatus?.map(status => status?.descricao).join(', ')}.
          <br />O gráfico mostra a quantidade em porcentagem de requerimentos por status no período selecionado, para
          visualizar ou exportar os dados preencha o filtro.
        </S.Descricao>
        <RelatorioStatusResumida dadosGrafico={dadosGrafico} filtroSelecionado={filtroSelecionado} />
      </Style.GlobalCard>
    </S.Page>
  );
}
